export default __webpack_public_path__ + "static/media/logo_uga.30748042.png";